export default __webpack_public_path__ + "static/media/49.1dfac59a.png";